import { render, staticRenderFns } from "./telone.vue?vue&type=template&id=612cd1fe"
import script from "./telone.vue?vue&type=script&lang=js"
export * from "./telone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports